module.exports = __webpack_public_path__ + "static/1-56570527931afd50972afe7f213dca70.png";